const SessionStorageKeys = {
  TOKEN: 'TOKEN' as 'TOKEN',
  EMAIL: 'EMAIL' as 'EMAIL',
};

type SessionStorageKeys = typeof SessionStorageKeys[keyof typeof SessionStorageKeys];

export { SessionStorageKeys };